import type { ReportGroup } from '../types';
import { overview } from './overview';

export const concierge = {
  key: 'concierge',
  label: 'Concierge',
  isEnabled: ({ isCheckoutPlusEnabled }) => isCheckoutPlusEnabled,
  isCorsoAdminOnly: true,
  filters: {},
  reports: [overview],
} as const satisfies ReportGroup;
